import React from "react";
import { Box } from "@mui/system";

const MainSectionContainer = ({ children }) => {
  return (
    <Box width="100%" height="100%" padding="10px">
      <Box height="100%" width="100%" borderRadius="12px">
        {children}
      </Box>
    </Box>
  );
};

export default MainSectionContainer;
